<template>
  <div class="ih-page-payment ih-page">
    <form @submit.prevent="submit()">
      <h3 class="ih-margin-bottom-15 text-center">請輸入序號</h3>
      <div class="ih-row-5 row">
        <div
          class="col-12">
          <div class="form-group">
            <div class="ih-theme-button-yellow">

              <input
                type="text"
                name="serial_no"
                id="serial_no"
                v-model="form_serial_no"
                style="width: 60%"
                autocomplete="off"
              />

            </div>
          </div>
        </div>
      </div>

      <br />

      <div class="alert alert-danger text-center" v-if="formError">請輸入序號</div>

      <div class="form-group">
        <div class="ih-row-5 row">
          <div class="col-6">
            <button type="button" class="ih-theme-button-white" @click="$router.go(-1)">回上一頁</button>
          </div>
          <div class="col-6">
            <button type="submit" class="ih-theme-button-yellow">確定</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>



<script>
export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      formError: false,

      form_serial_no: '',

      form_payment_method_id: 0
    };
  },

  computed: {

  },
  watch: {},
  methods: {
    submit() {

      this.$store.commit(
        "set_form_serial_no", this.form_serial_no
      );
      console.log(this.$store.state.form);

      $.ajax({
        method: "POST",
        url: `${this.apiBase}/api/v1/actives/serial-number/write-off`,
        data: this.$store.state.form
      })
        .done(res => {
          // 機器被佔用... 等等錯誤
          if (res.status !== 0) {
            this.$router.push({
              path: "/result",
              query: { message: "序號使用流程取消<br>請重新操作" }
            });

            return;
          }
          else{
            this.$router.push({
              path: "/result",
              query: { message: "序號使用成功<br>請稍待..." }
            });

            return;
          }
        })
        .fail(err => {
          this.$router.push({
            path: "/result",
            query: { message: err.message }
          });
        })
        .always(res => {});
    }
  },

  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/pages/Payment";
</style>
